module.exports = __webpack_public_path__ + "static/media/right_filled.47eb875c.svg";